import React from 'react';
import Head from 'next/head';

export const AppHead = () => (
  <Head>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, maximum-scale=5, minimum-scale=1"
    />
  </Head>
);
